import { clsx } from "clsx";

export const getFieldSetClassNames = ({ dir }: { dir?: "row" | "column" }) =>
  clsx(
    "relative bg-none border-0 flex my-[0.6rem] mx-0 p-0 w-full gap-small",
    dir === "row" && "flex-row",
  );

export const hiddenInputStyles =
  "absolute top-0 right-0 border-0 w-0 h-0 opacity-0 overflow-hidden outline-none";
